const countrySelectorOpener = document.querySelector('.footer__lang-opener');
const countrySelectorModal = document.querySelector('.country-selector__modal');
const countrySelectorClose = document.querySelector('.country-selector__modal-close');

if( countrySelectorOpener && countrySelectorModal ) {

    countrySelectorOpener.addEventListener('click',  () => {
        document.body.classList.add('overflow-hidden');
        countrySelectorModal.setAttribute('open', '');
        trapFocus( document.querySelector('.country-selector__modal--js'), document.querySelector('.country-selector__modal-wrapper--js') );
    });

    countrySelectorClose.addEventListener('click', () => {
        document.body.classList.remove('overflow-hidden');
        countrySelectorModal.removeAttribute('open', '');
        removeTrapFocus( document.querySelector('.country-selector__modal--js'), document.querySelector('.country-selector__modal-wrapper--js') );
    });

    window.onclick = function(event) {
        if (event.target == countrySelectorModal) {
            document.body.classList.remove('overflow-hidden');
            countrySelectorModal.removeAttribute('open', '');
            removeTrapFocus( document.querySelector('.country-selector__modal--js'), document.querySelector('.country-selector__modal-wrapper--js') );
        }
    };

}

const countrySelectorMenuWrapper = document.querySelectorAll('.country-selector__modal-item--has-dropdown');
countrySelectorMenuWrapper.forEach( element => {

    const countrySelectorMenuOpener = element.querySelector('.country-selector__modal-item__link--menu-opener');
    const countrySelectorMenu = element.querySelector('.country-selector__modal-item__menu-dropdown');

    countrySelectorMenuOpener.addEventListener('click', () => {
        countrySelectorMenu.classList.toggle('unrolled');
        element.querySelector('.country-selector__modal-item__arrow').classList.toggle('unrolled');
    });

});
